import {
  Chip as MuiChip,
  ChipProps as MuiChipProps,
  styled
} from '@mui/material';
import React from 'react';

export type ChipProps = Omit<MuiChipProps, 'size'> & {
  hasBullet?: boolean;
  bulletColor?: string;
  labelColor?: string;
  mode?: 'normal' | 'light';
  size?: 'small' | 'medium' | 'large';
};

/**
 * Chip component of Material is somthing like Badge ,
 * Material Ui Chip is wrapper for content that has
 * Background color and other various Props,
 * you can see Chip Documentation api that I mentioned below [here](https://mui.com/material-ui/api/chip)
 *
 * ```typescript
 *  import { Chip } from '@rabex-kit/core';
 *  ```
 *
 *
 * @param props
 * @returns
 */

const Chip: React.FC<ChipProps> = styled(MuiChip, {
  name: 'MuiChip',
  shouldForwardProp: prop =>
    !['hasBullet', 'bulletColor', 'labelColor'].includes(prop as string)
})<ChipProps>(() => ({}));

export default Chip;

Chip.defaultProps = {
  hasBullet: false,
  mode: 'normal',
  size: 'medium'
};
